module.exports = "/_next/static/images/9def27dc5fbd2e4883d765ddad8489f8-woman-playing-with-her-kids@xs.jpg.webp";